module.exports = __webpack_public_path__ + "media/images/banner-image-bth-0e1db2c4298adbedc9e14166907d2dc2.jpg";